<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'landing-page',

    computed:
    {
        ...mapGetters({page: 'page', channel: 'channel'}),

        bgStyle()
        {
            const desktopBg = this.page && this.page.desktop_images && this.page.desktop_images[0] ?
                this.page.desktop_images[0].display_url : null
            const mobileBg = this.page && this.page.mobile_images && this.page.mobile_images[0] ?
                this.page.mobile_images[0].display_url : null

            return this.$mq == 'md' ?
                {background: `url(${mobileBg}) no-repeat left center`} :
                {background: `url(${desktopBg}) no-repeat left center`}
        },
    },

}
</script>

<template>
<div id="coreg-container">
    <div class="signup-container">
        <div div class="py-2 coreg-header">
            <logo></logo>
        </div>
    </div>
    <div class="signup-container coreg-page" v-if="page">
        <div class="row no-gutters coreg-row">
            <div class="col-lg-10 h-100" :style="bgStyle">
                <div class="coreg-bg h-100">
                    <div class="signup-pic-text">
                        <h1 class="font-weight-semibold mb-4 text-capitalize juana">
                            {{ page.headline }}
                        </h1>
                        <p class="proximanova font-weight-semibold mb-0">
                            {{ page.excerpt }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 signup-form-side">
                <signup-form class="coreg-form"></signup-form>
            </div>
        </div>
    </div>
    <div class="signup-container">
        <div class="py-2 coreg-footer">
            {{ channel.footer }}
            &nbsp; <a href="https://loverly.com/privacy-policy" target="_blank">Privacy Policy</a>
        </div>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/components/landingPages/LandingPage.vue